import styled, { css } from 'styled-components';

import { Button } from 'features/common/components/Button';
import { Form } from 'features/common/components/Form';

export const CustomFieldsForm = styled(Form)<{ isPunchup: boolean }>`
	display: flex;
	gap: 12px;
	width: 100%;
	flex-direction: column;

	${({ isPunchup }) =>
		!isPunchup &&
		css`
			height: calc(100vh - 168px - 100px);
		`}

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		flex-direction: column;

		${({ isPunchup }) =>
			!isPunchup &&
			css`
				overflow: scroll;
				height: calc(100vh - 100px - 128px);
			`}
	}
`;
export const FormContainer = styled.div<{ isPunchup?: boolean }>`
	display: flex;
	justify-content: space-between;
	width: 100%;
	flex-direction: row;

	/* On the Punchup iframe the two 90vw sides crammed around the thin vertical separator read as
	   "glued together"; stack them vertically so each gets full width. */
	${({ isPunchup }) =>
		isPunchup &&
		css`
			flex-direction: column;
		`}

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		flex-direction: column;
	}
`;

export const FormSide = styled.div`
	width: 50%;
	display: flex;
	height: auto;
	flex-direction: column;
	width: 90vw;
`;

export const ButtonsContainer = styled.div<{ isPunchup: boolean }>`
	display: flex;
	width: 100%;
	border-top: 0.5px solid ${({ theme }) => theme.colors.white2};
	justify-content: center;
	gap: 32px;
	align-items: center;
	padding-bottom: 10px;
	padding-top: 16px;
	${({ isPunchup }) =>
		!isPunchup &&
		css`
			background: ${({ theme }) => theme.colors.blackGrey};
			position: absolute;
			height: 100px;
			bottom: 0;
		`}

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		gap: 8px;
		bottom: 0;
		border: none;

		${({ isPunchup }) =>
			!isPunchup &&
			css`
				position: fixed;
			`}
	}
`;

export const StyledButton = styled(Button)`
	width: fit-content;
	min-width: 300px;
	position: relative;
	bottom: 0;
	margin: 0;
	height: 56px;
	font-size: 18px;
	padding: unset;

	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		min-width: 150px;
	}
`;

export const DeleteButton = styled.button`
	width: fit-content;
	min-width: 50px;
	position: relative;
	bottom: 0;
	margin: 0;
	height: 40px;
	font-size: 16px;
	padding: 16px 53px;
	background-color: ${({ theme }) => theme.colors.red};
	color: ${({ theme }) => theme.colors.white};
	border: none;
	border-radius: 8px;
	cursor: pointer;
	font-family: ${({ theme }) => theme.fonts.primary};
	display: flex;
	align-items: center;
	justify-content: space-around;
	gap: 8px;

	&:hover {
		opacity: 0.9;
	}

	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		min-width: 150px;
	}
`;

export const FormSeparator = styled.div<{ isPunchup?: boolean }>`
	height: 85%;
	width: 1.5px;
	background-color: ${({ theme }) => theme.colors.grey10}20;

	/* When the form stacks vertically (Punchup), the separator becomes a full-width horizontal rule. */
	${({ isPunchup }) =>
		isPunchup &&
		css`
			height: 1.5px;
			width: 100%;
			margin: 4px 0;
		`}
`;

export const CustomFieldsFooter = styled.div`
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
	gap: 8px;
	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		justify-content: center;
		gap: 12px;
		flex-direction: col;
	}
`;

export const RowFlex = styled.div`
	display: flex;
	justify-content: center;
	gap: 6px;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		gap: 8px;
		width: 100%;
	}
`;
